
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { MobileInput, MobileTextarea, MobileButton } from "@/components/ui/mobile-form";
import MessageFormatToggle from "@/components/refund/basic-info/MessageFormatToggle";
import { ArrowRight } from "lucide-react";

interface FormData {
  merchant: string;
  issue: string;
  amount: string;
  currency: string;
  messageFormat: "email" | "chat";
}

interface SimplifiedRefundFormFieldsProps {
  formData: FormData;
  isSubmitting: boolean;
  isAuthenticated: boolean;
  hasUsedDemo: boolean;
  onFieldChange: (field: string, value: string) => void;
  onFormatChange: (format: "email" | "chat") => void;
  onSubmit: () => void;
}

const SimplifiedRefundFormFields = ({
  formData,
  isSubmitting,
  isAuthenticated,
  hasUsedDemo,
  onFieldChange,
  onFormatChange,
  onSubmit
}: SimplifiedRefundFormFieldsProps) => {
  return (
    <Card>
      <CardContent className="p-6 space-y-4">
        <MobileInput
          label="Store/Company Name"
          placeholder="e.g., Amazon, PayPal, Local Store"
          value={formData.merchant}
          onChange={(e) => onFieldChange('merchant', e.target.value)}
          required
        />

        <MobileTextarea
          label="What happened?"
          placeholder="Describe the issue with your purchase..."
          value={formData.issue}
          onChange={(e) => onFieldChange('issue', e.target.value)}
          required
        />

        <div className="grid grid-cols-2 gap-3">
          <MobileInput
            label="Amount"
            type="number"
            placeholder="0.00"
            value={formData.amount}
            onChange={(e) => onFieldChange('amount', e.target.value)}
            required
          />
          <MobileInput
            label="Currency"
            value={formData.currency}
            onChange={(e) => onFieldChange('currency', e.target.value)}
            required
          />
        </div>

        <MessageFormatToggle
          messageFormat={formData.messageFormat}
          onFormatChange={onFormatChange}
        />

        <MobileButton
          onClick={onSubmit}
          loading={isSubmitting}
          fullWidth
          className="mt-6"
        >
          {isSubmitting ? 'Creating Request...' : (
            <>
              {!isAuthenticated && hasUsedDemo ? 'Sign Up to Continue' : 'Create Request'}
              <ArrowRight className="w-4 h-4 ml-2" />
            </>
          )}
        </MobileButton>
      </CardContent>
    </Card>
  );
};

export default SimplifiedRefundFormFields;
